import React, { useEffect } from "react";
import "./BidDetailModel.css";

function formatAmount(value) {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "—";
  return `€${amount.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

function bidTypeLabel(type) {
  const key = String(type ?? "").toLowerCase();
  if (key === "1" || key === "manual") return "Manual";
  if (key === "2" || key === "proxy") return "Proxy";
  return type ? String(type) : "—";
}

const BidDetailsModal = ({ show, handleClose, bidsDetail }) => {
  useEffect(() => {
    if (!show) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") handleClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [show, handleClose]);

  if (!show) return null;

  const bids = Array.isArray(bidsDetail) ? bidsDetail : [];

  return (
    <div
      className="dp-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="dp-modal-title"
    >
      <button
        type="button"
        className="dp-modal__backdrop"
        aria-label="Close bid details"
        onClick={handleClose}
      />
      <div className="dp-modal__panel">
        <header className="dp-modal__head">
          <div>
            <p className="dp-modal__eyebrow">Auction activity</p>
            <h3 id="dp-modal-title">Bid history</h3>
          </div>
          <button
            type="button"
            className="dp-btn dp-btn--ghost"
            onClick={handleClose}
          >
            Close
          </button>
        </header>

        <div className="dp-modal__body">
          {bids.length ? (
            <table className="dp-modal__table">
              <thead>
                <tr>
                  <th scope="col">Amount</th>
                  <th scope="col">Type</th>
                  <th scope="col">Status</th>
                  <th scope="col">Winner</th>
                  <th scope="col">Placed</th>
                </tr>
              </thead>
              <tbody>
                {bids.map((bid, index) => (
                  <tr key={bid.id ?? index}>
                    <td className="dp-modal__amount">
                      {formatAmount(bid.bid_amount)}
                    </td>
                    <td>{bidTypeLabel(bid.bid_type)}</td>
                    <td>
                      <span
                        className={`dp-tag${
                          bid.status ? " dp-tag--ok" : " dp-tag--muted"
                        }`}
                      >
                        {bid.status ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`dp-tag${
                          bid.winner ? " dp-tag--gold" : " dp-tag--muted"
                        }`}
                      >
                        {bid.winner ? "Yes" : "No"}
                      </span>
                    </td>
                    <td className="dp-modal__date">
                      {bid.date ? new Date(bid.date).toLocaleString() : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="dp-modal__empty">No bids have been placed yet.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BidDetailsModal;
